import { useState } from 'react'

export const useModal = () => {
  const [fadeIn, setFadeIn] = useState<boolean>(false)
  const [fadeOut, setFadeOut] = useState<boolean>(false)
  const [modal, setModal] = useState<any>(false)

  const handleModal = (a: any) => {
    if (!!a) {
      setFadeIn(true)
      setFadeOut(false)
      setTimeout(() => {
        setModal(a)
      }, 50)
    } else {
      setFadeOut(true)
      setTimeout(() => {
        setFadeIn(false)
        setModal(a)
      }, 300)
    }
  }
  return { fadeIn, fadeOut, modal, handleModal }
}
